import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import AuthService from '../../services/auth'
import LoggedOutPage from '../../pages/logged-out-page'

export default class LogoutRoute extends Component {

    static propTypes = {
        path: PropTypes.string
    }

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        AuthService.logout()
    }

    render() {
        return <Route component={LoggedOutPage} />
    }

}



// WEBPACK FOOTER //
// src/components/auth/logout-route.js